import { render, staticRenderFns } from "./AppCheckBox.vue?vue&type=template&id=1a43ecca"
import script from "./AppCheckBox.vue?vue&type=script&lang=ts"
export * from "./AppCheckBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports